<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  },
  mounted() {
    if(this.$route.query.letterDetail == '1'){
      return;
    }
    if (this._isMobile()) {
      this.$router.replace("/mIndex");
    } else {
      this.$router.replace("/");
    }
  }
}
</script>


// WEBPACK FOOTER //
// App.vue?2d52dc01